

export default function countWords(v: string): number {
    /// fix problem in special characters such as middle-dot, etc.   
    const str = v.replace(/[\u007F-\u00FE]/g, ' ');

    /// make a duplicate first...
    let str1 = str;
    let str2 = str;

    /// the following remove all chinese characters and then count the number of english characters in the string
    str1 = str1.replace(/[^!-~\d\s]+/gi, ' ')

    /// the following remove all english characters and then count the number of chinese characters in the string
    str2 = str2.replace(/[!-~\d\s]+/gi, '')

    // Helper function to count words with length limit
    function countWordsWithLimit(text: string, maxWordLength: number = 15): number {
        let matches = text.match(/[\u00ff-\uffff]|\S+/g);
        if (!matches) return 0;
        
        let totalCount = 0;
        for (let match of matches) {
            if (match.length <= maxWordLength) {
                // Normal word, count as 1
                totalCount += 1;
            } else {
                // Long string, split into multiple words
                // Use a reasonable chunk size (average English word is ~5 chars)
                const chunkSize = 8;
                totalCount += Math.ceil(match.length / chunkSize);
            }
        }
        return totalCount;
    }

    let count1 = countWordsWithLimit(str1);
    let count2 = countWordsWithLimit(str2);

    /// return the total of the mixture
    return count1 + count2
}